import axios from "axios";

const state = {
    JambStep:1,
    JambItems:{},
};

const getters = {
    getJambStep(state){
        return state.JambStep
    },
    getJambItems(state){
        return state.JambItems
    },
};

const mutations = {
    setJambStep(state, payload) {
    state.JambStep = payload;
  },
  setJambItems(state, payload){
      state.JambItems=payload
  }
};

const actions = {

    JambAppValidationRequest({commit}, payload){
    commit("setLoading", true);
    commit("setSnackbar", false);
    console.log(payload)
    axios
      .post(`https://backoffice.teller.ng/TellerAppManager/api/JambValidationRequest?serviceType=${payload.serviceType}&confirmationCode=${payload.applicationID}`)
      .then(res => {
        console.log(res.data)
        if (res.data.status == 0) {
            commit("setJambStep", 2);
            commit("setJambItems", res.data);
        }
        else{
            commit("setSnackbar", true);
            commit("setServerMessage", res.data.message)
        } 
      })
      .catch(err => {
        commit("setSnackbar", true);
        commit("setServerMessage", err.message)
      })
      .finally(()=>{
        commit("setLoading", false);
      })
  },

  JambPayment({commit}, payload){
    commit("setLoading", true);
    commit("setSnackbar", false);
    console.log(payload)
    axios
      .post(`https://backoffice.teller.ng/TellerAppManager/api/JambProcurementRequest?customerID=${payload.customerID}&pin=${payload.pin}&confirmationCode=${payload.Items.confirmationCode}&candidateGsm=${payload.Items.candidateGsm}&serviceType=${payload.serviceType}&imei='12344'`)
      .then(res => {
        if (res.data.status == 0) {
            console.log(res.data)
            commit("setBalance",  res.data.updatedMainBalance );
            commit("setCommissionBalance",  res.data.updatedCommissionBalance );
            commit("setJambStep", 1);
            commit("getJambItems", {});
            commit("setSnackbar", true);
            commit("setServerMessage", "Successful")
            payload.route.push({name: "Successful"})
        }
        else{
            commit("setSnackbar", true);
            commit("setServerMessage", res.data.message)
        } 
      })
      .catch(err => {
        commit("setSnackbar", true);
        commit("setServerMessage", err.message)
      })
      .finally(()=>{
        commit("setLoading", false);
      })
  },
};

export default {
  state,
  mutations,
  getters,
  actions
};








